(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bgc-about"] && !Shopify.designMode) return;
  try {
    
function initBgcAbout(scope){
  scope.querySelectorAll('[data-bgc-about]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targets=root.querySelectorAll('[data-ab-reveal]');
    if(reduced||!('IntersectionObserver' in window)){
      targets.forEach(el=>el.classList.add('is-in'));
    }else{
      root.classList.add('ab-js');
      const io=new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target);}
        });
      },{rootMargin:'0px 0px -12% 0px',threshold:.12});
      targets.forEach(el=>io.observe(el));
    }
    const media=root.querySelector('[data-ab-parallax]');
    if(media&&!reduced){
      let ticking=false;
      const move=()=>{
        ticking=false;
        const rect=root.getBoundingClientRect();
        if(rect.bottom<0)return;
        const shift=Math.max(-60,Math.min(60,-rect.top*0.06));
        media.style.transform='translate3d(0,'+shift.toFixed(2)+'px,0) scale(1.06)';
      };
      const onScroll=()=>{if(!ticking){ticking=true;window.requestAnimationFrame(move);}};
      move();
      window.addEventListener('scroll',onScroll,{passive:true});
    }
  });
}
initBgcAbout(document);
document.addEventListener('shopify:section:load',event=>initBgcAbout(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bgc-header"]) return;
  try {
    
document.querySelectorAll('[data-bgc-header]').forEach(header=>{if(header.dataset.ready)return;header.dataset.ready='true';const update=()=>header.classList.toggle('is-scrolled',window.scrollY>24);update();window.addEventListener('scroll',update,{passive:true});header.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=header.querySelector('details[open]');if(opened){opened.open=false;opened.querySelector('summary').focus();}}});document.addEventListener('click',event=>{if(!header.contains(event.target))header.querySelectorAll('details[open]').forEach(d=>d.open=false);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bgc-hero"] && !Shopify.designMode) return;
  try {
    
function initBrushlandHero(root){root.querySelectorAll('[data-bgc-hero]').forEach(hero=>{if(hero.dataset.ready)return;hero.dataset.ready='true';const video=hero.querySelector('video'),button=hero.querySelector('.bgc-video-control');if(!video||!button)return;const reduced=matchMedia('(prefers-reduced-motion: reduce)');let manuallyPaused=false,retryArmed=false;
const sync=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause;};
const reconcile=()=>{video.classList.toggle('is-playing',!video.paused&&video.readyState>=2);sync();};
function attempt(){if(reduced.matches||manuallyPaused)return;video.muted=true;video.defaultMuted=true;const p=video.play();if(p&&p.catch)p.catch(err=>{console.warn('[bgc-hero] autoplay refused:',err.name,err.message);if(retryArmed)return;retryArmed=true;const go=()=>{if(!manuallyPaused&&video.paused)video.play().catch(()=>{});};['pointerdown','touchstart','click','keydown','scroll'].forEach(e=>document.addEventListener(e,go,{once:true,passive:true}));});}
button.hidden=false;button.addEventListener('click',()=>{if(video.paused){manuallyPaused=false;attempt();}else{manuallyPaused=true;video.pause();}});
video.addEventListener('playing',()=>{video.classList.add('is-playing');sync();});
video.addEventListener('pause',sync);
video.addEventListener('error',()=>{video.classList.remove('is-playing');button.hidden=true;});
video.addEventListener('loadeddata',reconcile);
reduced.addEventListener('change',()=>{if(reduced.matches)video.pause();});
attempt();reconcile();
if('IntersectionObserver' in window){new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)video.pause();else attempt();},{threshold:.1}).observe(hero);}});}
initBrushlandHero(document);document.addEventListener('shopify:section:load',event=>initBrushlandHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bgc-size-guide"] && !Shopify.designMode) return;
  try {
    
function initBgcFit(scope){
  scope.querySelectorAll('[data-bgc-unit]').forEach(chart=>{
    if(chart.dataset.ready)return;
    chart.dataset.ready='true';
    chart.querySelectorAll('[data-bgc-unit-btn]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const unit=btn.dataset.bgcUnitBtn;
        if(chart.dataset.bgcUnit===unit)return;
        chart.dataset.bgcUnit=unit;
        chart.querySelectorAll('[data-bgc-unit-btn]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));
      });
    });
  });
}
initBgcFit(document);
document.addEventListener('shopify:section:load',event=>initBgcFit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bgc-you-may-like"] && !Shopify.designMode) return;
  try {
    
function initBgcMore(scope){
  scope.querySelectorAll('[data-bgc-more]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const list=section.querySelector('[data-bgc-more-list]');
    if(!list)return;
    const cards=Array.prototype.slice.call(list.children).filter(el=>el.classList.contains('bgc-more-card'));
    if(cards.length<=3){cards.forEach(c=>c.classList.add('is-pick'));return;}
    for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));const t=cards[i];cards[i]=cards[j];cards[j]=t;}
    cards.forEach(c=>{c.classList.remove('is-pick');list.appendChild(c);});
    cards.slice(0,3).forEach(c=>{c.classList.add('is-pick');list.appendChild(c);});
    cards.slice(3).forEach(c=>list.appendChild(c));
  });
}
initBgcMore(document);
document.addEventListener('shopify:section:load',event=>initBgcMore(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
